import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from './Button';
import VideoPlay from './VideoPlay';
import Modal from './Modal';
import GlobalAPI from '../apis/GlobalAPI';

const VideoHelp = ({ onClose = () => {} }) => {
  const [url, setURL] = useState(undefined);

  useEffect(() => {
    GlobalAPI.getVideoHelpURL().then((url) => setURL(url));
  }, []);

  return (
    <ModalStyled>
      <Container>
        <VideoPlay url={url} />
        <ButtonStyled secondary text='Cancelar' onClick={onClose} />
      </Container>
    </ModalStyled>
  );
};

const ModalStyled = styled(Modal)`
  max-width: 300px;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const ButtonStyled = styled(Button)`
  margin-top: 10px;
`;


export default VideoHelp;
